<template>
  <div class="field">
    <label class="label">Preferred Work Region</label>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder="..."
        :value="value"
        @input="updateValue"
        @focusout="handleChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreferredWorkRegion',
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'string' || prop === null
    },
    applicantId: {
      type: Number,
      required: true
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    async handleChange () {
      try {
        await this.$network_utils.updateApplicant({ applicant_id: this.applicantId, preferred_work_region: this.value })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
